/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-07 11:54:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-09-15 14:25:55
 */
/* eslint-disable */
console.log('2022.10.09')
import Vue from 'vue'
import ElementUI from 'element-ui'
import NProgress from 'nprogress'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/element-variables.scss'
import 'nprogress/nprogress.css'
import App from '@/layouts/App.vue'
import router from '@/router/router'

//引入表格插件
import moreTreeTable from "more-tree-table"

Vue.use(moreTreeTable)
// 默认会找store目录下面的index.js文件
import store from '@/store'
import api from '@/api'
import config from '@/config/config'
import * as utils from '@/utils/utils'
import storage from '@/utils/localstorage'
import {common, login} from '@/mixins/index'
import '@/utils/filter.js'
import Clipboard from 'clipboard';
import '@/assets/iconfont.css'
import { debounce } from '@/utils/utils'

// 防抖
Vue.directive('debounce', {
  bind(el, binding) {
    const [fn, ...args] = binding.value;
    el.addEventListener('click', debounce(fn, args));
  },
  unbind(el, binding) {
    const [fn, ...args] = binding.value;
    el.removeEventListener('click', debounce(fn, args));
  }
})

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// console.log('hostname->', hostname)
// console.log('config->', config.domain)
store.commit('handleDomainInfo', config.domain)

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$config = config
Vue.prototype.$storage = storage
Vue.prototype.clipboard = Clipboard;
// Vue.config.errorHandler = function(err, vm, info) {
//   console.log(`Error: ${err.toString()}\nInfo: ${info}`);
// }
// console.log("config->", config)

Vue.use(ElementUI)
// 混入复用
Vue.mixin(common) // 公共方法
Vue.mixin(login) // 登录部分

router.beforeEach((to, from, next) => {
  // 如果合同审核不通过或者没上传
  let ico = document.getElementById("ico")
  ico.setAttribute("href",config.domain.ico_url|| (config.ossDomain+'/'+config.ossAppDir+   config.domain.icoUrl) );
  document.title =config.domain.alias_name||config.domain.title  
  
  if(to.path == '/mainDetail'&&config.domain.ename == 'kuaihuolong'){
	  if(to.query.type == '4'){
		  document.title = '灵工贷'
	  }
	  if(to.query.type == '3'){
	      document.title = '龙保宝'
	  }
	  if(to.query.type == '2'){
	      document.title = '园区资源'
	  }
  }
  
  if (to.path !== '/loginIndex') {
    // api.getUserProfile().then(function (userInfo) {
    //   store.commit('handleUserInfo', userInfo)
    //   console.log("userInfo", userInfo)
    // })
  }
  if (to.path !== '/' && to.path !== '/login') {
    const is_contract = store.state.isContract
    if (is_contract <= 0 || is_contract == 2) {
      return next({path: '/'})
    }
  }
  next()
})

router.afterEach((to, from, next) => {
  setTimeout(() => {
    var _mtac = {"performanceMonitor": 1};
    (function () {
      var mta = document.createElement("script");
      mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
      mta.setAttribute("name", "MTAH5");
      mta.setAttribute("sid", "500725142");
      mta.setAttribute("cid", "500725145");
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(mta, s);
    })();
  }, 0)
})

// router.beforeResolve((to, from, next) => {
//   if (to.path !== '/login') {
//     console.log("=========beforeResolve")
//   }
//   if (to.path !== '/agreement' && to.path !== '/login') {
//     const is_contract = storage.get('is_contract')
//     console.log("is_contract======", is_contract)
//     if (is_contract <= 0 || is_contract == 2) {
//       return next({path:'/agreement'})
//     }
//   } else if (to.path !== '/' && to.path !== '/login') {
//     const is_contract = storage.get('is_contract')
//     if (is_contract == 1) {
//       return next({path:'/'})
//     }
//   }
//   next()
// })

// router.afterEach(function (transition) {
//   NProgress.done()
//   NProgress.remove()
// })

// 配置NProgress进度条选项  —— 动画效果
NProgress.configure({ease: 'ease', speed: 500, showSpinner: false})
// 全局路由拦截-进入页面前执行
router.beforeEach((to, from, next) => {
  if (to.path === `/login`) {
    return next()
  }

  // NProgress开始进度条
  // NProgress.start()
  next()
})

// 全局后置钩子-常用于结束动画等
router.afterEach(transition => {
  // NProgress结束进度条
  // NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
